import React from 'react';
import styled from 'styled-components';

import Avatar from './DesignerAvatar';
import Link from '../InternalLink';

const DesignerDisplay = ({ designer, sewpatId }) => {
    const StyledThing = styled(Link)`
        font-family: ${props => props.theme.condensed};
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-right: ${props => props.theme.space[11]}
    `;

    const Attribution = designer.name ?
        <p >designed by <br />{designer.name},<br />patterndesigns.com</p > :
        null;

    return (
        <StyledThing
            to={{
                type: 'NAVIGATED_TO_PATTERNS_FROM_DESIGNER',
                payload: { designerid: designer.id, sewpatId },
            }}
        >
            <Avatar img={designer.profileImage || null} alt={designer.name || null} />
            {Attribution}
        </StyledThing >
    );
};

export default DesignerDisplay;



// WEBPACK FOOTER //
// ./src/components/designer/DesignerDisplay.js